import type { IntlShape } from 'react-intl';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { RemixDisabledReason } from '../malleableUiPluginType';
import { messages } from './messages';

/**
 * Returns the appropriate disabled tooltip message based on the reason remix is disabled.
 */
export const getRemixDisabledTooltip = (
	formatMessage: IntlShape['formatMessage'],
	reason?: RemixDisabledReason,
): string => {
	// Hosts always pass a reason with their own `isDisabled`, so no reason means the AI entry points
	// are disabled because an AI flow (e.g. a Rovo Remix stream) is running on the page.
	if (reason === undefined && fg('remix_state_rearchitecture_enabled')) {
		return formatMessage(messages.remixInProgressTooltip);
	}
	switch (reason) {
		case 'version-history':
			return formatMessage(messages.remixDisabledTooltipVersionHistory);
		case 'archived':
		default:
			return formatMessage(messages.remixDisabledTooltipArchived);
	}
};
